import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ShapeContainerBaseWrapper
} from './styled'

export class ShapeContainerBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      flex,
      direction,
      wrap,
      justify,
      align,
      width,
      widthUnit,
      minWidth,
      maxWidth,
      height,
      calcHeight,
      calcMinHeight,
      heightUnit,
      minHeight,
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      spacing,
      spacingTop,
      spacingRight,
      spacingBottom,
      spacingLeft,
      spacingHorizontal,
      spacingVertical,
      bgColor,
      bgHoverColor,
      borderWidth,
      borderStyle,
      borderColor,
      borderHoverColor,
      borderTopWidth,
      borderTopStyle,
      borderTopColor,
      borderTopHoverColor,
      borderRightWidth,
      borderRightStyle,
      borderRightColor,
      borderRightHoverColor,
      borderBottomWidth,
      borderBottomStyle,
      borderBottomColor,
      borderBottomHoverColor,
      borderLeftWidth,
      borderLeftStyle,
      borderLeftColor,
      borderLeftHoverColor,
      borderRadius,
      boxShadow,
      fluid,
      onClick,
      textHoverColor,
      iconHover,
      disabled,
      disabledColor,
      iconDisabled,
      disabledEventTooltips,
      overflow,
    } = this.props

    return (
      <ShapeContainerBaseWrapper
        className={ClassNames(
          'shape-container-base',
          { 'is-fluid': fluid },
          { 'is-cursor-pointer': onClick },
          { 'is-disabled': disabled },
          { 'is-disabled-event-tooltips': disabledEventTooltips },
          // Option
          className
        )}
        theme={{
          // Default
          flex,
          direction,
          wrap,
          justify,
          align,
          width,
          widthUnit,
          minWidth,
          maxWidth,
          height,
          calcHeight,
          calcMinHeight,
          heightUnit,
          minHeight,
          padding,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          spacing,
          spacingTop,
          spacingRight,
          spacingBottom,
          spacingLeft,
          spacingHorizontal,
          spacingVertical,
          bgColor,
          bgHoverColor,
          borderWidth,
          borderStyle,
          borderColor,
          borderHoverColor,
          borderTopWidth,
          borderTopStyle,
          borderTopColor,
          borderTopHoverColor,
          borderRightWidth,
          borderRightStyle,
          borderRightColor,
          borderRightHoverColor,
          borderBottomWidth,
          borderBottomStyle,
          borderBottomColor,
          borderBottomHoverColor,
          borderLeftWidth,
          borderLeftStyle,
          borderLeftColor,
          borderLeftHoverColor,
          borderRadius,
          boxShadow,
          textHoverColor,
          iconHover,
          disabledColor,
          iconDisabled,
          disabledEventTooltips,
          overflow
        }}
        onClick={onClick}
      >
        <div className='shape-container-content-base'>
          {children}
        </div>
      </ShapeContainerBaseWrapper>
    )
  }

  static defaultProps = {
    direction: 'column',
    wrap: 'wrap',
    align: 'flex-start',
    widthUnit: 'px',
    heightUnit: 'px'
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    flex: PropTypes.string,
    direction: PropTypes.string,
    wrap: PropTypes.string,
    justify: PropTypes.string,
    align: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    widthUnit: PropTypes.string,
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    calcHeight: PropTypes.string,
    calcMinHeight: PropTypes.string,
    heightUnit: PropTypes.string,
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bgColor: PropTypes.string,
    bgHoverColor: PropTypes.string,
    borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderHoverColor: PropTypes.string,
    borderTopWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderTopStyle: PropTypes.string,
    borderTopColor: PropTypes.string,
    borderTopHoverColor: PropTypes.string,
    borderRightWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderRightStyle: PropTypes.string,
    borderRightColor: PropTypes.string,
    borderRightHoverColor: PropTypes.string,
    borderBottomWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomStyle: PropTypes.string,
    borderBottomColor: PropTypes.string,
    borderBottomHoverColor: PropTypes.string,
    borderLeftWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderLeftStyle: PropTypes.string,
    borderLeftColor: PropTypes.string,
    borderLeftHoverColor: PropTypes.string,
    borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    boxShadow: PropTypes.string,
    fluid: PropTypes.bool,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    textHoverColor: PropTypes.string,
    iconHover: PropTypes.string,
    disabled: PropTypes.bool,
    disabledColor: PropTypes.string,
    iconDisabled: PropTypes.any,
    disabledEventTooltips: PropTypes.bool,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
